/**
 * Chat assistant endpoints.
 */

import type {
  SendChatMessageRequest as SendMessageRequest,
  SendChatMessageResponse as SendMessageResponse,
} from '@luminaria/shared';
import { apiClient } from './client';
import { API_ENDPOINTS } from './endpoints';

// The wire contracts are the shared ones (WEBD-20).
export type { SendMessageRequest };

export const chatApi = {
  async send(request: SendMessageRequest): Promise<SendMessageResponse> {
    const { data } = await apiClient.post<SendMessageResponse>(API_ENDPOINTS.CHAT.SEND, request);
    return data;
  },
};
